import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'jsx/elements/messages/Tooltip';

const TransactionKeyTag = ({ color, type, description }) => {

  let backgroundStyle = {
    background : color
  };

  return (
    <div className="calc-div-inline">
      <Tooltip id="transactionKeyTagTip" />
      <span className="calc-transactionkey-tag" style={backgroundStyle} data-tip={description} data-for="transactionKeyTagTip">{type}</span>
    </div>
  );
};

TransactionKeyTag.propTypes = {
  color: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
};

export default TransactionKeyTag;
